import {ShortcutEnum} from '@wallaby-ui/document';

export type UzisReportFilter = {
  dateFrom: string | null;
  dateTo: string | null;
  floatingShortcutName: ShortcutEnum | null;
  organizationIds: number[] | null;
  includeDrugChanges: string | null;
};

export type UzisReportVResult = {
  proc51: number;
  proc53: number;
  proc55: number;
  proc55other: number;
  proc52: number;
  iopdc: number;
};

export type UzisReportVIResult = {
  drugStarted: number;
  drugStopped: number;
  drugChanged: number;
};

export type UzisReportVIIResult = {
  low: number;
  medium: number;
  high: number;
};

export type UzisReportVIIIResult = {
  polypharmacy: number;
  nti: number;
  hip: number;
  renalInsufficiency: number;
  hepaticInsufficiency: number;
  significantChanges: number;
  intensiveCare: number;
  diabetesMellitus: number;
  epilepsy: number;
  fibrillation: number;
  tumor: number;
  corticosteroids: number;
  parkinson: number;
};

export type UzisReportData = {
  tableV: UzisReportVResult;
  tableVLoading: boolean;
  tableVI: UzisReportVIResult;
  tableVILoading: boolean;
  tableVII: UzisReportVIIResult;
  tableVIILoading: boolean;
  tableVIII: UzisReportVIIIResult;
  tableVIIILoading: boolean;
};

export type FiltersData = {
  report: UzisReportFilter;
  savedFiltersOpen: boolean;
};

export const DEFAULT_UZIS_REPORT_FILTERS = (firstHospitalId?: number): UzisReportFilter => {
  const now = new Date();
  const currentYear = now.getFullYear();

  const lastCompleteYear = currentYear - 1;

  return {
    dateFrom: `${lastCompleteYear}-01-01`,
    dateTo: `${lastCompleteYear}-12-31`,
    floatingShortcutName: ShortcutEnum.PREVIOUS_YEAR,
    organizationIds: firstHospitalId ? [firstHospitalId] : null,
    includeDrugChanges: 'EXCLUDE_DRUG_CHANGES',
  };
};

export const UZIS_REPORT_LAYOUT_SPLIT_CONFIG = (layoutId: string) => [
  {
    sizes: [44, 87, 66, 66, 322],
    minSize: [44, 87, 66, 66, 322],
    layoutId,
  },
];

// '/'-prefixed like every other split's storageId: logout's cleanLocalStorage('/') only removes '/'-prefixed
// keys, so the old un-prefixed 'uzis-report-main-layout' survived logouts (and the id rename also discards
// any stale persisted size, so existing users get the new autoFit default).
export const getUzisReportLayoutId = () => '/LightSplitLayout.MerieUzisReportLayout';
